import React, { useEffect, useRef } from 'react';
import { Field } from 'formik';
import axios from 'axios';
import { getHeaders } from '../../../request/index';
import { SttAutocomplete} from '@stt-componentes/core';
import { UF, MUNICIPIO } from '../fieldNames';
import { PERFIL } from '../../../common/Constants';
import { temPerfilRBAC } from '../../../secutity/rbac';
import { useSignal, useSignalEffect } from '@preact/signals-react';
import usuario from '../../../signals/usuario';
import { batch } from '@preact/signals-react';
import { listar } from '../../../signals/exame';

const Uf = ( props ) => {
	const { strings } = props;
	
    const formRef = useRef();
    
    const ufs = useSignal([]);
    const municipios = useSignal([]);
    const filtroPorLocal = useSignal(false);
    const filtroPorRede = useSignal(false);
    const filtroPorFuncionario = useSignal(false);
    const carregarUfs = useSignal(false);   

    const UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;

    useSignalEffect(() => {
        if (listar.value && formRef.current) {
            formRef.current.handleSubmit();
        }
    })

    useEffect(() => {
        if (temPerfilRBAC(usuario, [PERFIL.ADMINISTRADOR, PERFIL.ADMINISTRADOR_ESTADUAL])) {
            batch(() => {
                carregarUfs.value = true;
                filtroPorLocal.value = true;
                filtroPorRede.value = true;
                filtroPorFuncionario.value = true;
            });
        }
        if (temPerfilRBAC(usuario, PERFIL.MEDICO_SOLICITANTE)) {
            batch(() => {
                carregarUfs.value = true;
                filtroPorLocal.value = true;
            });
        }
        if (temPerfilRBAC(usuario, PERFIL.VISUALIZADOR_REDE)) {
            batch(() => {
                carregarUfs.value = true;
                filtroPorLocal.value = true;
            });
        }
    }, []);

    useSignalEffect(() => {
        if (carregarUfs.value) {
            let url = `${UTILITARIOS_API_BASE_URL}/localizacao/estado`;
            if (temPerfilRBAC(usuario, PERFIL.ADMINISTRADOR_ESTADUAL)) {
                const perfil = usuario.value.perfisRBAC.filter(p => p.identificador === PERFIL.ADMINISTRADOR_ESTADUAL);
                const estados = perfil[0].estados;
                const idsUf = estados.map(e => e.id);
                url = `${url}?ids=${idsUf.join(',')}`;
            }

            axios.get(url, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        ufs.value = itens;
                    }
                })
                .catch(err => console.log(err));
        }
    })

    const handleChangeUf = (uf) => {
        municipios.value = [];
        if (filtroPorLocal.value && uf) {
            axios.get(`${UTILITARIOS_API_BASE_URL}/localizacao/cidade?id-estado=${uf.id}`, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        municipios.value = itens;
                    } else {
                        municipios.value = [];
                    }
                })
                .catch(err => console.log(err));
        }
    }

    return (

        <Field name={UF}>
            {({
                field: { name, value, onBlur },
                form: { setFieldValue }
            }) => (
                <SttAutocomplete
                    inputprops={{
                        name: name,
                        label: strings.uf
                    }}
                    getOptionLabel={option => option?.sigla || ''}
                    getOptionSelected={(option, val) => option?.id === val?.id}
                    options={ufs.value}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e, item) => {
                        setFieldValue(UF, item || null);
                        setFieldValue(MUNICIPIO, null);
                        handleChangeUf(item);
                    }}
                />
            )}
        </Field>
    );
};

export default Uf;
